import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { BookedForSalesEvents, BookedForSalesProduct } from '../../api-client';

// Define a type for the slice state
interface CustomerBookedForSalesState {
    bookedForSales: BookedForSalesProduct[];
    bookedForSalesEventRecap: BookedForSalesEvents[];
};


// Define the initial state using that type
const initialState: CustomerBookedForSalesState = {
    bookedForSales: [],
    bookedForSalesEventRecap: []
}

export const customerBookedForSalesSlice = createSlice({
    name: 'customerBookedForSales',
    // `createSlice` will infer the state type from the `initialState` argument
    initialState,
    reducers: {
        initCustomerBookedForSales: (state, action: PayloadAction<BookedForSalesProduct[]>) => {
            state.bookedForSales = action.payload;
        },

        initCustomerBookedForSaleEventRecap: (state, action: PayloadAction<BookedForSalesEvents[]>) => {
            state.bookedForSales = action.payload;
        }
    }
});

export const { initCustomerBookedForSales, initCustomerBookedForSaleEventRecap } = customerBookedForSalesSlice.actions;

export default customerBookedForSalesSlice.reducer;